<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <div class="nav-title-wrap">
          <span class="nav-devname">{{ udname }}</span>
          <span class="nav-did">设备日志</span>
        </div>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <van-tabs v-model="activeTab" class="crystal-tabs" :swipeable="true" color="#2dd4bf" title-active-color="#2dd4bf" title-inactive-color="#94a3b8">
        <van-tab title="全部">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">事件</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in allLogs" :key="'all-' + i" class="log-row">
              <div class="log-col log-col--val">
                <span class="log-tag" :class="tagClass(item)">{{ formatName(item) }}</span>
                <span v-if="showDesc(item)" class="log-desc">{{ formatDesc(item) }}</span>
              </div>
              <span class="log-col log-col--time">{{ item.time || '' }}</span>
            </div>
            <div v-if="allLogs.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
        <van-tab title="输出">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">状态</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in outputLogs" :key="'out-' + i" class="log-row">
              <span class="log-col log-col--val">
                <span class="log-tag" :class="tagClass(item)">{{ formatName(item) }}</span>
              </span>
              <span class="log-col log-col--time">{{ item.time || '' }}</span>
            </div>
            <div v-if="outputLogs.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
        <van-tab title="定时">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">状态</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in timerLogs" :key="'tmr-' + i" class="log-row">
              <span class="log-col log-col--val">
                <span class="log-tag" :class="tagClass(item)">{{ formatName(item) }}</span>
              </span>
              <span class="log-col log-col--time">{{ item.time || '' }}</span>
            </div>
            <div v-if="timerLogs.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
        <van-tab title="信号">
          <div class="log-card">
            <div class="log-table-header">
              <span class="log-col log-col--val">状态</span>
              <span class="log-col log-col--time">记录时间</span>
            </div>
            <div v-for="(item, i) in signalLogs" :key="'sig-' + i" class="log-row">
              <span class="log-col log-col--val">
                <span class="log-tag" :class="tagClass(item)">{{ formatName(item) }}</span>
              </span>
              <span class="log-col log-col--time">{{ item.time || '' }}</span>
            </div>
            <div v-if="signalLogs.length === 0" class="log-empty">暂无记录</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "KS2Log",
  data() {
    return {
      activeTab: 0,
      did: this.$route.query.did,
      udname: this.$route.query.udname || "KS-2 设备",
      allLogs: [],
    };
  },
  computed: {
    outputLogs() {
      return this.allLogs.filter((l) => l.name === "out");
    },
    timerLogs() {
      return this.allLogs.filter((l) => l.name === "tmr" || l.name === "cyc" || l.name === "dly");
    },
    signalLogs() {
      return this.allLogs.filter((l) => l.name === "sig");
    },
  },
  mounted() {
    this.gethistory();
  },
  methods: {
    gethistory() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/ks2/log", qs.stringify({
          did: this.did,
          tnum: 7,
          tunit: "day",
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            var buf = response.data.data || {};
            var raw = buf.log_buf || buf.log || [];
            this.allLogs = this.parseLogs(raw);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { });
    },
    parseLogs(raw) {
      if (!raw || !Array.isArray(raw)) return [];
      return raw.map((entry) => {
        if (Array.isArray(entry)) {
          var parsed = entry[0];
          if (typeof parsed === "string") {
            try { parsed = JSON.parse(parsed); } catch (e) {}
          }
          parsed.time = entry[1];
          return parsed;
        }
        return entry || {};
      }).filter((item) => item && item.name);
    },
    formatName(item) {
      if (item.name === "out") {
        if (item.val === "1") return "输出开启";
        if (item.val === "0") return "输出关闭";
      }
      if (item.name === "tmr") {
        if (item.val === "1") return "24h 定时开始";
        if (item.val === "0") return "24h 定时结束";
      }
      if (item.name === "cyc") {
        if (item.val === "1") return "间歇定时开始";
        if (item.val === "0") return "间歇定时结束";
      }
      if (item.name === "dly") {
        if (item.val === "1") return "延时关闭启动";
        if (item.val === "0") return "延时开启启动";
        if (item.val === "ok") return "延时到期执行";
        if (item.val === "c") return "延时取消";
      }
      if (item.name === "sig") {
        if (item.val === "1") return "信号异常·输出切断";
        if (item.val === "0") return "信号恢复正常";
      }
      if (item.name === "volt_alm_low")  return "电压过低";
      if (item.name === "volt_alm_high") return "电压过高";
      if (item.name === "volt_alm_ok")   return "电压恢复";
      if (item.name === "curr_alm_low")  return "电流过低";
      if (item.name === "curr_alm_high") return "电流过高";
      if (item.name === "curr_alm_ok")   return "电流恢复";
      return item.name;
    },
    formatDesc(item) {
      if (item.name === "volt_alm_low" || item.name === "volt_alm_high")
        return item.val + "V";
      if (item.name === "curr_alm_low" || item.name === "curr_alm_high")
        return item.val + "A";
      if (item.name === "volt_alm_ok" || item.name === "curr_alm_ok")
        return "已恢复正常";
      return item.val;
    },
    showDesc(item) {
      return (
        item.val &&
        item.val !== "0" &&
        item.val !== "1" &&
        (item.name === "volt_alm_low" || item.name === "volt_alm_high" ||
         item.name === "curr_alm_low" || item.name === "curr_alm_high" ||
         item.name === "volt_alm_ok" || item.name === "curr_alm_ok")
      );
    },
    tagClass(item) {
      if (item.name === "volt_alm_ok") return "log-tag--success";
      if (item.name === "curr_alm_ok") return "log-tag--success";
      if (item.name === "sig" && item.val === "0") return "log-tag--success";
      if (item.name === "sig" && item.val === "1") return "log-tag--danger";
      if (item.name.indexOf("volt_alm") === 0) return "log-tag--danger";
      if (item.name.indexOf("curr_alm") === 0) return "log-tag--warning";
      if (item.name === "out" && item.val === "1") return "log-tag--success";
      if (item.name === "out" && item.val === "0") return "log-tag--info";
      if (item.name === "tmr" && item.val === "1") return "log-tag--success";
      if (item.name === "tmr" && item.val === "0") return "log-tag--info";
      if (item.name === "cyc" && item.val === "1") return "log-tag--success";
      if (item.name === "cyc" && item.val === "0") return "log-tag--info";
      return "log-tag--info";
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}
.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}
.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}
.nav-did {
  font-size: 11px;
  color: #94a3b8;
}
.crystal-tabs .van-tabs__wrap {
  box-shadow: 0 1px 0 #f1f5f9;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh; min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}
.content-area {
  padding: 12px; display: flex; flex-direction: column; gap: 12px;
}
.log-card {
  background: #ffffff; border-radius: 14px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04);
  overflow: hidden; margin-top: 10px;
}
.log-table-header {
  display: flex;
  align-items: center;
  background: #f8fafc;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.log-row {
  display: flex; align-items: center;
  padding: 12px 16px; border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.log-row:last-child { border-bottom: none; }
.log-row:active { background: #f8fafc; }
.log-col {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}
.log-col--val {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.log-col--time {
  flex-shrink: 0;
  text-align: right;
  color: #94a3b8;
  font-weight: 400;
  font-size: 12px;
}
.log-table-header .log-col {
  font-weight: 600;
  color: #64748b;
  font-size: 12px;
}
.log-table-header .log-col--time {
  color: #64748b;
  font-weight: 600;
}
.log-tag {
  display: inline-block; padding: 2px 8px; border-radius: 6px;
  font-size: 11px; font-weight: 600; flex-shrink: 0;
}
.log-tag--success { background: rgba(45,212,191,0.12); color: #0d9488; }
.log-tag--info { background: rgba(148,163,184,0.15); color: #64748b; }
.log-tag--danger { background: rgba(251,113,133,0.12); color: #e11d48; }
.log-tag--warning { background: rgba(251,191,36,0.15); color: #b45309; }
.log-desc {
  font-size: 12px; color: #94a3b8;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.log-empty { text-align: center; padding: 40px 20px; font-size: 14px; color: #94a3b8; }
</style>
